import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export default function DelDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    props.Confirm();
    handleClose();
  };

  return (
    <React.Fragment>
      <Tooltip title="Excluir">
        <IconButton onClick={handleClickOpen}  aria-label="delete" size="small">
          <DeleteIcon fontSize="inherit"/>
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirma excluir esse item?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tenha certeza de ter escolhido o item correto, essa ação é irreversível!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} sx={{ color: 'red' }}>Sim</Button>
          <Button onClick={handleClose} autoFocus variant="contained" sx={{ color: 'white' }}>
            Não
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}